import {
  intervalISODateToDateRange,
  isIntervalISODate,
} from '@epicuro-next/utilities';

import { DeliveryPeriodType } from '../models';

export function mapBulkDeliveryPeriodToFuture(
  deliveryPeriod: string,
  deliveryPeriodType: DeliveryPeriodType | undefined,
) {
  if (
    deliveryPeriodType === DeliveryPeriodType.Bulk ||
    (deliveryPeriodType === undefined && isIntervalISODate(deliveryPeriod))
  ) {
    return intervalISODateToDateRange(deliveryPeriod).from;
  }

  return deliveryPeriod;
}
